import { Component, OnInit } from '@angular/core';
import { CountrycurrencypageService } from './countrycurrencypage.service';
import { MetaService } from 'src/app/shared/services/meta.service';
import { ActivatedRoute } from '@angular/router';
import { CanonicalService } from 'src/app/shared/services/canonical.service';
import { CurrenciespageService } from '../currenciespage.service';
import { CountryCurrencyHeroComponent } from './country-currency-hero/country-currency-hero.component';
import { CommonCompaniesPanelComponent } from 'src/app/shared/components/companies-panel/companies-panel.component';
import { CountryCurrencyFeatureComponent } from './country-currency-feature/country-currency-feature.component';
import { CountryCurrencyExchangeRateComponent } from './country-currency-exchange-rate/country-currency-exchange-rate.component';
import { CountryCurrencySubscribeFormComponent } from './country-currency-subscribe-form/country-currency-subscribe-form.component';
import { CountryCurrencyCoverageComponent } from './country-currency-coverage/country-currency-coverage.component';
import { CommonLatestNewsComponent } from 'src/app/shared/components/latest-news/latest-news.component';
import { CommonGetstartedComponent } from 'src/app/shared/components/getstarted/getstarted.component';
import { PosthogService } from 'src/app/shared/services/posthog.service';

@Component({
  selector: 'app-country-currency',
  templateUrl: './country-currency.component.html',
  styleUrls: ['./country-currency.component.scss'],
  imports: [
    CountryCurrencyHeroComponent,
    CommonCompaniesPanelComponent,
    CountryCurrencyFeatureComponent,
    CountryCurrencyExchangeRateComponent,
    CountryCurrencySubscribeFormComponent,
    CountryCurrencyCoverageComponent,
    CommonLatestNewsComponent,
    CommonGetstartedComponent,
  ],
})
export class CountryCurrencyComponent implements OnInit {
  companiesData:any;
  newsList:any;
  getStartedData:any;
  pageData:any;
  constructor(
    private currenciesPageService: CurrenciespageService,
    private countryCurrencyPageService: CountrycurrencypageService,
    private meta: MetaService,
    private route: ActivatedRoute,
    private canonical: CanonicalService,
    private posthogService: PosthogService
  ) {}

  async ngOnInit(): Promise<void> {
    try {
      // this.currenciesPageService.getCurrenciesPageData();
      const continent = this.route.snapshot.paramMap.get('continent');
      const currencyname = this.route.snapshot.paramMap.get('currencyname');
      
      if (!continent || !currencyname) {
        console.error('Missing route parameters');
        return;
      }
      
      const detail = `${continent}/${currencyname}`;
      this.countryCurrencyPageService.getCountryCurrencyDetailByIDData(detail);
      
      const fetchedData = await this.countryCurrencyPageService.getCurrencyAllData();
      if (!fetchedData || !Array.isArray(fetchedData)) {
        console.error('Failed to fetch currency data');
        return;
      }
      
      const matchedData = fetchedData.filter(el => el?.fields?.id?.toLowerCase() === detail?.toLowerCase());
      if (!matchedData || matchedData.length === 0) {
        console.warn(`No data found for currency: ${detail}`);
        return;
      }
      
      this.pageData = matchedData[0]?.fields;
      this.posthogService.capturePageViewEvent(currencyname);
      
      if (!this.pageData) {
        console.warn(`No fields found for currency: ${detail}`);
        return;
      }
      
      // Update meta tags safely
      if (this.pageData?.seoMetadataReference?.fields) {
        this.meta.updateMeta(this.pageData.seoMetadataReference.fields);
      }
      
      const data = this.pageData;
      if (data != null) {
        // Safely extract company logos
        const logos = data?.customerTestimonialsContentPanel?.fields?.image?.map(
          (el:any) => el?.fields?.file?.url
        ) || [];
        this.companiesData = logos;
        
        // Safely extract news list
        this.newsList = data.psLatestNewsBlogPanel?.[0]?.fields;
      }
      
      // Safely extract get started data
      const getStartData = this.pageData?.getStartedContentPanel?.fields;
      if (getStartData != null) {
        this.getStartedData = {
          header: getStartData?.title,
          content: getStartData?.content,
          button1: {
            url: getStartData?.buttons?.[0]?.fields?.redirectLink,
            text: getStartData?.buttons?.[0]?.fields?.buttonText,
            target: getStartData?.buttons?.[0]?.fields?.actionType,
          },
          button2: {
            url: getStartData?.buttons?.[1]?.fields?.redirectLink,
            text: getStartData?.buttons?.[1]?.fields?.buttonText,
            target: getStartData?.buttons?.[1]?.fields?.actionType,
          },
        };
      }
      
      this.canonical.setCanonicalURL();
    } catch (error) {
      console.error('Error in CountryCurrencyComponent ngOnInit:', error);
    }
  }
}
